import { actionEmitter, EmitEvent } from "../config/ActionEmitter";
import { IApiResponse, IPrivacyNotice } from "../models/Interfaces";
import { BaseService } from "./BaseService";

export class PrivacyAndCookieService extends BaseService {
  
  public getPrivacyNotices = async (enabledOnly: boolean = false) : Promise<Array<IPrivacyNotice>> => {
    if (this.siteKey) {
      const url: string = `/SiteAdmin/GetCookieNotices/${this.siteKey}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200 && res?.ReturnData) {
        return res.ReturnData;
      } else {
        if (res?.StatusCode !== 404) {
          this.EmitDataError(res, "Failed to retrieve privacy notice data");
        }
      }
    }
    return [];
  }

  public savePrivacyNotice = async (notice: IPrivacyNotice) : Promise<IPrivacyNotice | null> => {
    if (this.siteKey && notice) {
      const url: string = `/SiteAdmin/AddUpdateCookieMessage`;
      const res = await this._ajaxService.Post<IApiResponse>(url, notice, true);

      if (res?.StatusCode === 200 && res?.ReturnData) {
        return res.ReturnData;
      } else {
        this.EmitDataError(res, "Failed to save privacy notice");
      }
    }
    return null;
  } 

  public deletePrivacyNotice = async (noticeid: number) : Promise<boolean> => {
    if (this.siteKey && !isNaN(noticeid)) {
      const url: string = `/SiteAdmin/DeleteCookieMessage/${this.siteKey}/${noticeid}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);

      if (res?.StatusCode === 200 && res?.ReturnData) {
        return true;
      } else {
        this.EmitDataError(res, "Failed to remove privacy notice");
      }
    }
    return false;
  }

  public newPrivacyNotice = () : IPrivacyNotice | null => {
    if (this.siteKey) {
      return {
        Id: 0,
        SiteId: this.siteKey,
        AgreeButtonText: "",
        BackgroundColour: "",
        ButtonClass: "",
        ContainerClass: "",
        DisplayText: "",
        Enabled: true,
        Language: "",
        Location: "",
        PolicyUrl: "",
        PolicyUrlLinkText: "",
        TextColour: ""
      };
    }
    return null;
  }
}